
module.exports.getConfig = function()
{
    return {
                applicationId: 'Default.App.Id',
           }
}